const IS_DEV_USTAWOTEKA_MODE = import.meta.env.VITE_IS_DEV_USTAWOTEKA_MODE === 'true';

export const APP_TESTY = 'testy';
export const APP_USTAWOTEKA = 'ustawoteka';
export const APP_LOCALHOST = 'localhost';
export const APP_OTHER = 'other';
export const APP_MODE =
	window.location.hostname === 'testy.iusvitae.pl' || window.location.hostname === 'mobile.iusvitae.com.pl'
		? APP_TESTY
		: window.location.hostname === 'ustawoteka.iusvitae.pl' || IS_DEV_USTAWOTEKA_MODE
			? APP_USTAWOTEKA
			: window.location.hostname === 'localhost'
				? APP_LOCALHOST
				: APP_OTHER;
